import React from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import ResetPassword from "pages/Authentication/ResetPassword"

// header dropdown routes
import UserProfile from "../pages/Authentication/user-profile"
import UserSettings from "pages/Authentication/user-settings"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

// Main Routes
import Staff from "pages/Staff"
import Students from "pages/Students"
import Applications from "pages/Applications"
import ApplicationForm from "pages/Applications/application-form"
import DonarMaster from "pages/Donation/DonarMaster"
import Donations from "pages/Donation/Donations"
import Reimbursement from "pages/Donation/Reimbursement"
import ResetPasswordLink from "pages/Authentication/resetPasswordLink"

// Error Routes.
import PagesBlank from "../pages/Extra Pages/pages-blank"
import Pages404 from "../pages/Extra Pages/pages-404"
import Pages500 from "../pages/Extra Pages/pages-500"
import Recommendations from "pages/Recommendations"
import Chat from "pages/Chat/Chat"
import CommitteeChat from "pages/ChatCommittee"
import ReturningStudents from "pages/ReturningStudents"

// Other Routes Not in use

// // Pages Calendar
// import Calendar from "../pages/Calendar/index"

// //Email
// import EmailInbox from "../pages/Email/email-inbox"
// import EmailRead from "../pages/Email/email-read"
// import EmailCompose from "../pages/Email/email-compose"

// // Inner Authentication
// import Login1 from "../pages/AuthenticationInner/Login"
// import Register1 from "../pages/AuthenticationInner/Register"
// import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
// import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

// //Charts
// import ChartsAppex from "../pages/Charts/charts-appex"
// import ChartsJs from "../pages/Charts/charts-chartjs"
// import ChartsKnob from "../pages/Charts/charts-knob"
// import ChartsC3 from "../pages/Charts/charts-c3"
// import ChartsSparkLine from "../pages/Charts/charts-sparkline"

// // Maps
// // import MapsGoogle from "../pages/Maps/MapsGoogle"
// import MapsVector from "../pages/Maps/MapsVector"

// //Icons
// import IconMaterialdesign from "../pages/Icons/IconMaterialdesign"
// import Iconion from "../pages/Icons/Iconion"
// import IconFontawesome from "../pages/Icons/IconFontawesome"
// import IconThemify from "../pages/Icons/IconThemify"
// import IconDripicons from "../pages/Icons/IconDripicons"
// import IconTypicons from "../pages/Icons/IconTypicons"

// //Tables
// import BasicTables from "../pages/Tables/BasicTables"
// import DatatableTables from "../pages/Tables/DatatableTables"
// import ResponsiveTables from "../pages/Tables/ResponsiveTables"
// import EditableTables from "../pages/Tables/EditableTables"

// // Forms
// import FormElements from "../pages/Forms/FormElements"
// import FormAdvanced from "../pages/Forms/FormAdvanced"
// import FormEditors from "../pages/Forms/FormEditors"
// import FormValidations from "../pages/Forms/FormValidations"
// import FormUpload from "../pages/Forms/FormUpload"
// import FormXeditable from "../pages/Forms/FormXeditable"

// //Ui
// import UiAlert from "../pages/Ui/UiAlert"
// import UiButtons from "../pages/Ui/UiButtons"
// import UiBadge from "../pages/Ui/UiBadge"
// import UiCards from "../pages/Ui/UiCards"
// import UiCarousel from "../pages/Ui/UiCarousel"
// import UiDropdown from "../pages/Ui/UiDropdown"
// import UiGrid from "../pages/Ui/UiGrid"
// import UiImages from "../pages/Ui/UiImages"
// import UiLightbox from "../pages/Ui/UiLightbox"
// import UiModal from "../pages/Ui/UiModal"
// import UiPagination from "../pages/Ui/UiPagination"
// import UiPopoverTooltips from "../pages/Ui/UiPopoverTooltips"
// import UiProgressbar from "../pages/Ui/UiProgressbar"
// import UiTabsAccordions from "../pages/Ui/UiTabsAccordions"
// import UiTypography from "../pages/Ui/UiTypography"
// import UiVideo from "../pages/Ui/UiVideo"
// import UiSessionTimeout from "../pages/Ui/UiSessionTimeout"
// import UiRangeSlider from "../pages/Ui/UiRangeSlider"

// //Extra Pages
// import PagesTimeline from "../pages/Extra Pages/pages-timeline"
// import PagesInvoice from "../pages/Extra Pages/pages-invoice"
// import PagesDirectory from "../pages/Extra Pages/pages-directory"
// import UiUtilities from "pages/Ui/UiUtilities"
// import UiColors from "pages/Ui/UiColors"
// import UiOffcanvas from "pages/Ui/UiOffcanvas"
// import Chat from "pages/Chat/Chat"
// import Kanban from "pages/Kanban"

const adminRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/staff", component: <Staff /> },
  { path: "/students", component: <Students /> },
  { path: "/recommendations", component: <Recommendations /> },
  { path: "/returningStudents", component: <ReturningStudents /> },
  {
    path: "/returningStudents/:applicationId",
    component: (
      <ApplicationForm hideSidebar isReturning backPath="/returningStudents" />
    ),
  },
  { path: "/applications", component: <Applications /> },
  { path: "/applications/:applicationId", component: <ApplicationForm /> },
  { path: "/committee-chat", component: <CommitteeChat /> },
  // { path: "/chat", component: <Chat /> },

  // // //profile
  // header dropdown
  { path: "/profile", component: <UserProfile /> },
  { path: "/settings", component: <UserSettings /> },

  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  // { path: "/staff", component: <Staff /> },
  { path: "/recommendations", component: <Recommendations /> },
  { path: "/returningStudents", component: <ReturningStudents /> },
  {
    path: "/returningStudents/:applicationId",
    component: (
      <ApplicationForm hideSidebar isReturning backPath="/returningStudents" />
    ),
  },
  { path: "/students", component: <Students /> },
  { path: "/applications", component: <Applications /> },
  { path: "/applications/:applicationId", component: <ApplicationForm /> },
  { path: "/committee-chat", component: <CommitteeChat /> },
  // { path: "/chat", component: <Chat /> },

  // // //profile
  // header dropdown
  { path: "/profile", component: <UserProfile /> },
  { path: "/settings", component: <UserSettings /> },

  // // Donation
  // { path: "/donation/donar-master", component: <DonarMaster /> },
  // { path: "/donation/donations", component: <Donations /> },
  // { path: "/donation/reimbursement", component: <Reimbursement /> },
  // { path: "/calendar", component: <Calendar /> },

  // // { path: "/chat", component: <Chat /> },
  // { path: "/kanbanboard", component: <Kanban /> },

  // // //Email
  // { path: "/email-inbox", component: <EmailInbox /> },
  // { path: "/email-read", component: <EmailRead /> },
  // { path: "/email-compose", component: <EmailCompose /> },

  // // //Charts
  // { path: "/apex-charts", component: <ChartsAppex /> },
  // { path: "/charts-chartjs", component: <ChartsJs /> },
  // { path: "/charts-knob", component: <ChartsKnob /> },
  // { path: "/charts-c3", component: <ChartsC3 /> },
  // { path: "/sparkline-charts", component: <ChartsSparkLine /> },

  // // // Icons
  // { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  // { path: "/icons-ion", component: <Iconion /> },
  // { path: "/icons-fontawesome", component: <IconFontawesome /> },
  // { path: "/icons-themify", component: <IconThemify /> },
  // { path: "/icons-dripicons", component: <IconDripicons /> },
  // { path: "/icons-typicons", component: <IconTypicons /> },

  // // // Tables
  // { path: "/tables-basic", component: <BasicTables /> },
  // { path: "/tables-datatable", component: <DatatableTables /> },
  // { path: "/tables-responsive", component: <ResponsiveTables /> },
  // { path: "/tables-editable", component: <EditableTables /> },

  // // // Maps
  // // { path: "/maps-google", component: <MapsGoogle /> },
  // { path: "/maps-vector", component: <MapsVector /> },

  // // // Forms
  // { path: "/form-elements", component: <FormElements /> },
  // { path: "/form-advanced", component: <FormAdvanced /> },
  // { path: "/form-editors", component: <FormEditors /> },
  // { path: "/form-uploads", component: <FormUpload /> },
  // { path: "/form-validation", component: <FormValidations /> },
  // { path: "/form-xeditable", component: <FormXeditable /> },

  // // // Ui
  // { path: "/ui-alerts", component: <UiAlert /> },
  // { path: "/ui-buttons", component: <UiButtons /> },
  // { path: "/ui-badge", component: <UiBadge /> },
  // { path: "/ui-cards", component: <UiCards /> },
  // { path: "/ui-carousel", component: <UiCarousel /> },
  // { path: "/ui-dropdowns", component: <UiDropdown /> },
  // { path: "/ui-grid", component: <UiGrid /> },
  // { path: "/ui-images", component: <UiImages /> },
  // { path: "/ui-lightbox", component: <UiLightbox /> },
  // { path: "/ui-modals", component: <UiModal /> },
  // { path: "/ui-pagination", component: <UiPagination /> },
  // { path: "/ui-popover-tooltip", component: <UiPopoverTooltips /> },
  // { path: "/ui-progressbars", component: <UiProgressbar /> },
  // { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  // { path: "/ui-typography", component: <UiTypography /> },
  // { path: "/ui-video", component: <UiVideo /> },
  // { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  // { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  // { path: "/ui-utilities", component: <UiUtilities /> },
  // { path: "/ui-colors", component: <UiColors /> },
  // { path: "/ui-offcanvas", component: <UiOffcanvas /> },

  // // //Extra Pages
  // { path: "/pages-timeline", component: <PagesTimeline /> },
  // { path: "/pages-invoice", component: <PagesInvoice /> },
  // { path: "/pages-directory", component: <PagesDirectory /> },
  // { path: "/pages-blank", component: <PagesBlank /> },

  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/ResetPassword", component: <ResetPassword /> },
  // { path: "/reset-password", component: <ResetPassword /> },
  // { path: "/reset-password-link/:id/:key", component: <ResetPasswordLink /> },
  // { path: "/register", component: <Register /> },

  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  // { path: "/pages-login", component: <Login1 /> },
  // { path: "/pages-register", component: <Register1 /> },
  // { path: "/page-recoverpw", component: <Recoverpw /> },
  // { path: "/auth-lock-screen", component: <LockScreen /> },
]

export { adminRoutes, userRoutes, authRoutes }
